package com.rikonardo.pluginscan.framework.jar

class JarEntry(val path: String, val content: ByteArray)